import { format, startOfMonth, subMonths } from "date-fns";

import type { EarningBar } from "routes/dashboard/default/components/EarningsWidget/TotalEarnings/types";

export const CHART_CONFIG = {
  HEIGHT: 400,
  WIDTH: 500,
  CHART_HEIGHT: 348,
  MARGIN: { top: 20, right: 30, left: 20, bottom: 5 },
  BORDER_RADIUS: 8,
} as const;

export const TIME_RANGES = {
  THREE_MONTHS: 2,
  SIX_MONTHS: 5,
  TWELVE_MONTHS: 11,
} as const;

export const EARNING_BARS: EarningBar[] = [
  { dataKey: "online_assessment", translationKey: "ONLINE_ASSESSMENT", colorKey: "r100" },
  { dataKey: "re_eval", translationKey: "RE_EVAL", colorKey: "b100" },
  { dataKey: "rtm_initial", translationKey: "RTM_INITIAL", colorKey: "g100" },
  { dataKey: "rtm_first", translationKey: "RTM_FIRST", colorKey: "t100" },
  { dataKey: "rtm_additional", translationKey: "RTM_ADDITIONAL", colorKey: "o100" },
  { dataKey: "rtm_adherence", translationKey: "RTM_ADHERENCE", colorKey: "p100" },
];

export const initialMonthCount = TIME_RANGES.THREE_MONTHS;
export const initialStartDate = format(subMonths(startOfMonth(new Date()), initialMonthCount), "yyyy-MM-dd");
